export default __webpack_public_path__ + "static/media/sign-out.3c1065ce.svg";